<div class="user-sessions-container">
  <header class="page-header">
    <div>
      <h1>User Sessions</h1>
      <p>Review user activity, session duration, and project access.</p>
    </div>
    <button type="button" class="report-button" (click)="downloadReport()" [disabled]="isExporting">
      <fa-icon [icon]="faDownload"></fa-icon>
      <span>{{ isExporting ? 'Preparing...' : 'Download report' }}</span>
    </button>
  </header>

  <section class="filters-panel" aria-label="Session filters">
    <div class="filter-grid">
      <div class="field-group">
        <label for="session-user">User</label>
        <select id="session-user" class="form-control" [(ngModel)]="selectedUserId" name="selectedUserId">
          <option *ngFor="let u of users" [value]="u.id">{{u.name}}</option>
        </select>
      </div>
      <div class="field-group">
        <label for="session-range">Date range</label>
        <select id="session-range" class="form-control" [(ngModel)]="selectedDateRange"
          (change)="onDateRangeChange()" name="selectedDateRange">
          <option *ngFor="let d of dateRanges">{{d}}</option>
        </select>
      </div>
      <div class="field-group" *ngIf="selectedDateRange === 'Custom'">
        <label for="session-from">From</label>
        <input id="session-from" type="date" class="form-control" [(ngModel)]="fromDate" name="fromDate" />
      </div>
      <div class="field-group" *ngIf="selectedDateRange === 'Custom'">
        <label for="session-to">To</label>
        <input id="session-to" type="date" class="form-control" [(ngModel)]="toDate" name="toDate" />
      </div>
      <button type="button" class="search-button" (click)="search()" [disabled]="isLoading">
        <fa-icon [icon]="faSearch"></fa-icon>
        <span>{{ isLoading ? 'Loading...' : 'Apply filters' }}</span>
      </button>
    </div>
  </section>

  <section class="summary-bar" aria-label="Session summary">
    <div class="summary-metric">
      <span class="metric-icon"><fa-icon [icon]="faClock"></fa-icon></span>
      <span class="metric-copy">
        <small>Active time on this page</small>
        <strong>{{ totalActiveHours }}</strong>
      </span>
    </div>
    <div class="summary-metric">
      <span class="metric-icon metric-icon--users"><fa-icon [icon]="faUsers"></fa-icon></span>
      <span class="metric-copy">
        <small>Total sessions</small>
        <strong>{{ totalItems }}</strong>
      </span>
    </div>
    <div class="group-control">
      <label for="report-grouping">Report grouping</label>
      <select id="report-grouping" class="form-control" [(ngModel)]="selectedGroupingOption">
        <option value="">No grouping</option>
        <option *ngFor="let group of ['Date','Project', 'User']" [value]="group">{{group}}</option>
      </select>
    </div>
  </section>

  <section class="sessions-panel">
    <div class="table-heading">
      <div>
        <h2>Session activity</h2>
        <span>{{ getResultSummary() }}</span>
      </div>
    </div>
    <div class="loading-state" *ngIf="isLoading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Loading sessions...
    </div>
    <div class="table-wrapper" *ngIf="!isLoading">
      <table class="custom-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Date</th>
            <th>Session start</th>
            <th>Last request</th>
            <th>Active time</th>
            <th class="details-col">Projects</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of displayedSessionsPaged">
            <td data-label="User"><span class="user-name">{{s.UserLoginName}}</span></td>
            <td data-label="Date">{{s.Date | date:'MMM d, y'}}</td>
            <td data-label="Session start">{{s.SessionStart | date:'shortTime'}}</td>
            <td data-label="Last request">{{s.LastPostback | date:'shortTime'}}</td>
            <td data-label="Active time"><span class="duration-pill">{{s.UserActiveHours}}</span></td>
            <td data-label="Projects" class="details-col">
              <button type="button" class="view-button" title="View project activity"
                (click)="openAccessedProjects(s)">
                <fa-icon [icon]="faEye"></fa-icon>
                <span>View</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="displayedSessionsPaged.length === 0">
            <td colspan="6" class="empty-state">
              <fa-icon [icon]="faCalendarAlt"></fa-icon>
              <strong>No sessions found</strong>
              <span>Try changing the user or date range.</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-wrapper" *ngIf="!isLoading && totalItems > 0">
      <span class="record-count">Showing {{ getFirstRecord() }}-{{ getLastRecord() }} of {{totalItems}}</span>
      <nav *ngIf="pager.totalPages > 1" aria-label="Session pages">
        <ul class="pagination mb-0">
          <li class="page-item" [class.disabled]="page === 1">
            <button class="page-link page-arrow" type="button" (click)="prevPage()" [disabled]="page === 1"
              title="Previous page" aria-label="Previous page">
              <fa-icon [icon]="faChevronLeft"></fa-icon>
            </button>
          </li>
          <li class="page-item" *ngFor="let p of pager.pages" [class.active]="p === page">
            <button class="page-link" type="button" (click)="setPage(p)">{{p}}</button>
          </li>
          <li class="page-item" [class.disabled]="page === pager.totalPages">
            <button class="page-link page-arrow" type="button" (click)="nextPage()"
              [disabled]="page === pager.totalPages" title="Next page" aria-label="Next page">
              <fa-icon [icon]="faChevronRight"></fa-icon>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</div>
